import { SignzyService } from "../application/services/SignzyService";
import { signzyAdapter } from "../infra/adaptor/signzy.adaptor";

export const buildSignzy = () => {
  const repo = new signzyAdapter();
  const service = new SignzyService(repo);

  return { service };
}